import { createContext } from "react";

/** The active VisitFrame action destination. This carries no action/result state. */
export const VisitTaskFoot = createContext<{
  target: HTMLElement | null;
  activeBoxIds: ReadonlySet<string>;
} | null>(null);
